module.exports = __webpack_public_path__ + "img/Dantam Hair 31b.5005b4da.jpg";